import React from 'react';

import {
  ToastContainer,
} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import Header from './Header';
import Sidebar from './Sidebar';
import Offsidebar from './Offsidebar';
import Footer from './Footer';

const Base = (props) => (
  <div className="wrapper">
    {props.clean ? props.children : (
      <>
        <Header />

        <Sidebar />

        <Offsidebar />

        <section className="section-container">
          { props.children }
        </section>

        {props.footer && props.footer}

        <ToastContainer stacked />
      </>
    )}
  </div>
);

export default Base;
